import s from "./ConnectWithUs.module.css";
import { useTranslation } from "react-i18next";

import { ConnectMethod } from "@components/ConnectWithUs/ConnectMethod";

import robot from "@assets/images/emoji-happy.svg";
import tg from "@assets/images/tg.svg";
// import google from "@assets/images/google.svg";

const ConnectWithUs = () => {
  const { t } = useTranslation();

  const redirectCreator = async () => {
    window.location.href = 'https://t.me/molodost_tvoya';
  }

  const redirectBot = async () => {
    window.location.href = 'https://t.me/bforgame_bot?start=mysite';
  }

  // const redirectEmail = async (event) => {
  //   window.location.href = 'mailto:dimapanky01@gmail.com';
  // }

  return (
    <div className={s.connestWithUsContainer}>
      <div className={s.connestWithUs}>
        <div className={s.title}>{t("ConnectWithUs.connection")}</div>
        
        <div className={s.buttons}>
          <ConnectMethod title={t("ConnectWithUs.bots")} redirect={redirectBot} imgSrc={robot} imgStyle={'imgRobot'} />
          <ConnectMethod title={"@molodost_tvoya"} redirect={redirectCreator} imgSrc={tg} imgStyle={'imgTg'} />
          {/* <ConnectMethod title={"dimapanky01@gmail.com"} redirect={redirectEmail} imgSrc={google} imgStyle={'connestBtn'} /> */}
        </div>
      </div>
    </div>
  );
};

export default ConnectWithUs;
